import React, { useState, useEffect, lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Landing from './pages/Landing';
import SeoRota from './SeoRota';
const carregarLogin = () => import('./pages/Login');
const Login = lazy(carregarLogin);
const carregarRegistro = () => import('./pages/Registro');
const Registro = lazy(carregarRegistro);
const carregarBiometria = () => import('./pages/Biometria');
const Biometria = lazy(carregarBiometria);
const carregarCadastro = () => import('./pages/Cadastro');
const Cadastro = lazy(carregarCadastro);
const carregarFoto = () => import('./pages/Foto');
const Foto = lazy(carregarFoto);
const carregarAutorizacao = () => import('./pages/Autorizacao');
const Autorizacao = lazy(carregarAutorizacao);
const carregarAssinatura = () => import('./pages/Assinatura');
const Assinatura = lazy(carregarAssinatura);
const carregarEnvio = () => import('./pages/Envio');
const Envio = lazy(carregarEnvio);
const carregarPlanos = () => import('./pages/Planos');
const Planos = lazy(carregarPlanos);
const carregarPrivacidade = () => import('./pages/Privacidade');
const Privacidade = lazy(carregarPrivacidade);
const carregarTermos = () => import('./pages/Termos');
const Termos = lazy(carregarTermos);
const carregarEsqueciSenha = () => import('./pages/EsqueciSenha');
const EsqueciSenha = lazy(carregarEsqueciSenha);
const carregarEsqueciEmail = () => import('./pages/EsqueciEmail');
const EsqueciEmail = lazy(carregarEsqueciEmail);
const carregarRedefinirSenha = () => import('./pages/RedefinirSenha');
const RedefinirSenha = lazy(carregarRedefinirSenha);
const carregarConfirmado = () => import('./pages/Confirmado');
const Confirmado = lazy(carregarConfirmado);
const carregarAdminLimpeza = () => import('./pages/AdminLimpeza');
const AdminLimpeza = lazy(carregarAdminLimpeza);
const carregarExcluirConta = () => import('./pages/ExcluirConta');
const ExcluirConta = lazy(carregarExcluirConta);
const todasAsTelas = [carregarLogin, carregarRegistro, carregarBiometria, carregarCadastro, carregarFoto, carregarAutorizacao, carregarAssinatura, carregarEnvio, carregarPlanos, carregarPrivacidade, carregarTermos, carregarEsqueciSenha, carregarEsqueciEmail, carregarRedefinirSenha, carregarConfirmado, carregarAdminLimpeza, carregarExcluirConta];

function App() {
  const [dados, setDados] = useState(null);

  // As telas são carregadas sob demanda (a página inicial abre mais rápido).
  // Para não depender de internet boa no meio do uso — por exemplo, em
  // campo —, assim que a página inicial termina de abrir o navegador baixa
  // as demais telas em segundo plano, nos momentos ociosos.
  useEffect(() => {
    const precarregar = () => { todasAsTelas.forEach((carregar) => { carregar().catch(() => {}); }); };
    if ('requestIdleCallback' in window) {
      const id = window.requestIdleCallback(precarregar, { timeout: 4000 });
      return () => window.cancelIdleCallback(id);
    }
    const t = setTimeout(precarregar, 2500);
    return () => clearTimeout(t);
  }, []);

  return (
    <BrowserRouter>
      <SeoRota />
      <Suspense fallback={null}>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/registro" element={<Registro />} />
        <Route path="/biometria" element={<Biometria />} />
        <Route path="/cadastro" element={<Cadastro setDados={setDados} />} />
        <Route path="/foto" element={<Foto />} />
        <Route path="/autorizacao" element={<Autorizacao dados={dados} />} />
        <Route path="/assinatura" element={<Assinatura dados={dados} />} />
        <Route path="/envio" element={<Envio dados={dados} />} />
        <Route path="/planos" element={<Planos />} />
        <Route path="/privacidade" element={<Privacidade />} />
        <Route path="/termos" element={<Termos />} />
        <Route path="/esqueci-senha" element={<EsqueciSenha />} />
        <Route path="/esqueci-email" element={<EsqueciEmail />} />
        <Route path="/redefinir-senha" element={<RedefinirSenha />} />
        <Route path="/confirmado" element={<Confirmado />} />
        <Route path="/admin-limpeza" element={<AdminLimpeza />} />
        <Route path="/excluir-conta" element={<ExcluirConta />} />
      </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
export default App;
